import { useQuery } from '@tanstack/react-query';
import { useInfoStore } from 'store/useInfoStore';

import { getNotificationCheck } from './service';

export const useGetNotificationCheck = () => {
  const { accessToken } = useInfoStore();

  return useQuery({
    queryKey: ['notificationCheck'],
    queryFn: getNotificationCheck,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    staleTime: 0,
    gcTime: 0,

    enabled: !!accessToken,
  });
};
